import React, { useEffect, useRef } from 'react';

import { mount } from 'redom';

import NativePositionControl from './';

import './index.scss';

function NativePositionControlReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativePositionControlReference = useRef(null);

  useEffect(function onLoad() {

    if (nativePositionControlReference.current !== null) {
      return;
    }

    const nativePositionControl = new NativePositionControl(props);

    nativePositionControlReference.current = nativePositionControl;

    mount(wrapperMainReference.current, nativePositionControlReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativePositionControlReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'position-control-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativePositionControlReactWrapper;